module.exports = __webpack_public_path__ + "static/media/logo_rw.17035279.svg";